const GRID_COLUMNS = 60;
export {
  GRID_COLUMNS
};
